import wconsole from 'malt-ui/utils/wconsole';
import { useEffect } from 'react';

const COOKIE_PREFERENCES_CONTAINER_ID = 'teconsent';
const TRUSTARC_NOTICE_SCRIPT_SELECTOR = 'script[src*="consent.trustarc.com/notice"]';

type TrustArcNotice = {
  eu?: {
    icon?: {
      initialize?: () => void;
    };
  };
};

declare global {
  interface Window {
    truste?: TrustArcNotice;
  }
}

/**
 * Mounts the container that the TrustArcScript fills with the cookie-preferences link.
 * That script runs before the footer exists, so this asks TrustArc to write the link once the container is on the page.
 */
export const TrustArcCookiePreferencesLink = () => {
  useEffect(() => {
    const populate = () => {
      const container = document.getElementById(COOKIE_PREFERENCES_CONTAINER_ID);
      if (!container || container.childNodes.length > 0) {
        return;
      }
      window.truste?.eu?.icon?.initialize?.();
    };

    if (window.truste?.eu?.icon) {
      populate();
      return;
    }

    const script = document.querySelector(TRUSTARC_NOTICE_SCRIPT_SELECTOR);
    script?.addEventListener('load', populate);
    return () => {
      script?.removeEventListener('load', populate);
    };
  }, []);

  return <div id={COOKIE_PREFERENCES_CONTAINER_ID} />;
};

/**
 * Mounts the TrustArcScript in the document head
 */
export const TrustArcScript = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.async = true;
    script.src =
      'https://consent.trustarc.com/notice?domain=workday.com&pn=2-0&c=teconsent&language=en-us&text=true&pcookie=true&cdn=1&gtm=true';
    script.setAttribute('data-trustarc', 'true');
    document.head.prepend(script);
    return () => {
      wconsole.error('TrustArcScript component unmounted, but script remains.');
    };
  }, []);
  return null;
};
